/**
 * Primary 3 Math tuition information page.
 *
 * What: Landing page for Primary 3 Mathematics tuition using LevelPageLayout.
 * Why: Provides targeted information for parents searching for P3 Math support.
 * When: Update when P3 syllabus changes or messaging refinements are needed.
 */
import React, { useMemo } from 'react';

import LevelPageLayout from '@/components/levels/LevelPageLayout.js';
import SchoolDirectory from '@/components/schools/SchoolDirectory.js';
import { toLevelPageLayoutContent } from '@/content/levelPageLayoutAdapter';
import { buildPrimaryContent } from '@/content/levels/primaryContent';
import { useSchoolDirectory } from '@/hooks/useSchoolDirectory.js';

function Primary3Page() {
  const layoutContent = useMemo(
    () =>
      toLevelPageLayoutContent(buildPrimaryContent('primary3'), {
        levelLabel: 'Primary 3',
      }),
    []
  );
  const { schools, isLoading, hasLoadError } = useSchoolDirectory({
    schoolType: 'primary',
  });

  return (
    <LevelPageLayout content={layoutContent}>
      <SchoolDirectory
        schools={schools}
        heading="Primary Schools in Singapore"
        isLoading={isLoading}
        emptyStateMessage={
          hasLoadError
            ? 'Unable to load schools right now.'
            : 'No schools found for this zone.'
        }
      />
    </LevelPageLayout>
  );
}

export default Primary3Page;
